import * as React from 'react'
import { Link } from 'gatsby'
import Layout from '.././components/layout'
import Employee from '.././components/employee'
import AdayIn from '.././components/aDayin'
import TuitionRates from '.././components/tuitionRates'
import ProgramSlider from '.././components/programSlider'
import JSONDat from ".././data/adayin/preschool-yellow.json"
import { StaticImage } from 'gatsby-plugin-image'
import { introImage } from '.././components/styles/page.module.scss'
import { employeesWrap } from '.././components/styles/employee.module.scss'
import Slider from "react-slick";
import { Helmet } from 'react-helmet';
import preschool1 from '.././images/programs/preschool/preschool1.jpg';
import preschool2 from '.././images/programs/preschool/preschool2.jpg';
import preschool3 from '.././images/programs/preschool/preschool3.jpg';
import preschool4 from '.././images/programs/preschool/preschool4.jpg';
import preschool5 from '.././images/programs/preschool/preschool5.jpg';
import preschool6 from '.././images/programs/preschool/preschool6.jpg';
import preschool7 from '.././images/programs/preschool/preschool7.jpg';
import preschool8 from '.././images/programs/preschool/preschool8.jpg';
import preschool9 from '.././images/programs/preschool/preschool9.jpg';
import preschool10 from '.././images/programs/preschool/preschool10.jpg';
import preschool11 from '.././images/programs/preschool/preschool11.jpg';
import { sliderImg } from '.././components/styles/layout.module.scss'

const PPage = () => {
    
  const pageTitle = "Preschool";
  const metaDesc = "Preschool in Santa Maria for children ages 2 to 4 years. Columbia Children's Center helps preschoolers build confidence, early academic skills, and strong social development in a safe, play-based classroom.";
  const ageRange = "2 years to 4 years";
  const faqSchema = {
    '@type': 'FAQPage',
    '@id': 'https://columbiachildrenscenter.com/preschool/#faq',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'What age is your preschool program?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Our preschool program is designed for children ages 2 to 4 years.',
        },
      },
      {
        '@type': 'Question',
        name: 'What does your Santa Maria preschool program focus on?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'We focus on confidence building, self-esteem, listening skills, early cognitive development, language growth, social development, and hands-on learning through centers, circle time, art, music, and movement.',
        },
      },
      {
        '@type': 'Question',
        name: 'Do you offer full-day preschool in Santa Maria?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Yes. Our preschool program offers both half-day and full-day schedule options, and extra days may also be arranged with the director.',
        },
      },
    ],
  };
  
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

    return (
      <Layout
        pageTitle={pageTitle}
        titleOverride="Preschool Program in Santa Maria, CA | Columbia Children's Center"
        metaDesc={metaDesc}
        pathname="/preschool/"
        schemaData={[faqSchema]}
      >
        <Helmet>
          <link
          rel="stylesheet"
          type="text/css"
          charset="UTF-8"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
        />
      </Helmet>
        <StaticImage src=".././images/home/preschool.jpg" width={500} className={introImage} alt="Preschool classroom at Columbia Children's Center in Santa Maria" />
        <h2 id="age"  style={{marginTop: "0"}}>{ageRange}</h2>
        <a href="https://app.tryplayground.com/X7tvoDUHwazFjm1hgbal/book/j2qKHKe4akbD4Cv9DED7" target="_blank" rel="noopener noreferrer" style={{ display: 'inline-block', marginBottom: '1rem', padding: '0.75rem 1.5rem', backgroundColor: '#007bff', color: '#fff', textDecoration: 'none', borderRadius: '0.375rem', fontWeight: 'bold' }}>Book a Tour</a>
        <p>Our Santa Maria preschool program provides a fun, safe, and positive environment that emphasizes confidence building and self-esteem. Children in this classroom strengthen listening skills and early cognitive skills such as color, shape, alphabet, and number recognition.</p>
        <p>Our daily schedule includes circle time, which promotes social development, sharing, cooperation and participation as a group. Math and Science activities reinforce practice counting, recognizing numbers, colors, sizes and shapes, as well as scissor practice. Story time and a language arts activity promote language development, alphabet and name recognition, individual expression and creativity. We have music and movement to develop skills of expression, rhythm, listening, coordination, as well as large motor skills.</p>
        <p>Our classroom has centers such as Science, Reading, Dramatic Play, Manipulative, and Art. These centers encourage your child's learning experience. Our maximum teacher to child ratio is 1:12.</p>
        <p>
          If you are comparing options for a preschool in Santa Maria, you can also visit our
          <Link to="/preschool-santa-maria/"> Santa Maria preschool page</Link> for location details, FAQs,
          and tour information.
        </p>
        {/* <ProgramSlider programImages="preschool"/> */}
        <AdayIn pageTitle="Preschool">
          <div>
            <h3>Yellow Group</h3>
            <ul>
              {JSONDat.days.map((data, index) => (
                <li key={index}>
                  <strong>{data.time}</strong> {data.day}
                </li>
              ))} 
            </ul>
          </div> 
        </AdayIn>

        <Slider {...settings}>
          <img className={sliderImg} src={preschool1} alt="Preschool" />
          <img className={sliderImg} src={preschool2} alt="Preschool" />
          <img className={sliderImg} src={preschool3} alt="Preschool" />
          <img className={sliderImg} src={preschool4} alt="Preschool" />
          <img className={sliderImg} src={preschool5} alt="Preschool" />
          <img className={sliderImg} src={preschool6} alt="Preschool" />
          <img className={sliderImg} src={preschool7} alt="Preschool" />
          <img className={sliderImg} src={preschool8} alt="Preschool" />
          <img className={sliderImg} src={preschool9} alt="Preschool" />
          <img className={sliderImg} src={preschool10} alt="Preschool" />
          <img className={sliderImg} src={preschool11} alt="Preschool" />
        </Slider>     

        <AdayIn pageTitle="Preschool" group="red">
          <div>
            <h3>Red Group</h3>
            <ul>
              {JSONDat.days.map((data, index) => (
                <li key={index}>
                  <strong>{data.time}</strong> {data.day}
                </li>
              ))} 
            </ul>
          </div> 
        </AdayIn>  

        <TuitionRates 
            pageTitle={pageTitle} 
            halfDayFive="$230" 
            fullDayFive="$310" 
            halfDayFour="$200" 
            fullDayFour="$260" 
            halfDayThree="$165" 
            fullDayThree="$210" 
            halfDayTwo="$135" 
            fullDayTwo="$165">
            Single extra days may be arranged with the director at a rate of half day: $75, full day: $90.
        </TuitionRates>
        <h2>Preschool FAQs</h2>
        <h3>What age is your preschool program?</h3>
        <p>Our preschool program is designed for children ages 2 to 4 years.</p>
        <h3>What does your Santa Maria preschool program focus on?</h3>
        <p>We focus on confidence building, self-esteem, listening skills, early cognitive development, language growth, social development, and hands-on learning through centers, circle time, art, music, and movement.</p>
        <h3>Do you offer full-day preschool in Santa Maria?</h3>
        <p>Yes. Our preschool program offers both half-day and full-day schedule options, and extra days may also be arranged with the director.</p>
        <div className={employeesWrap}>
            <Employee 
                employeeName="Elizabeth Pantoja" 
                employeeTitle="Preschool Teacher" 
                employeeImg="Elizabeth"
            />
            <Employee 
                employeeName="Katherine Chenoweth" 
                employeeTitle="Preschool Teacher" 
                employeeImg="Katherine"
            />
            <Employee 
                employeeName="Hailey Fakoury" 
                employeeTitle="Preschool Assistant" 
                employeeImg="Hailey"
            />
            <Employee 
                employeeName="Brigitte Ortiz-Tello" 
                employeeTitle="Outdoor Lead Teacher" 
                employeeImg="Brigitte"
            />
        </div>

      </Layout>
    )
  }
  
  export default PPage
